(function ($)
{
    var mSlideOpenerCounter = 0;
    
    $.widget("ui.SlideOpener",
    {
        options:
        {
            DisplaySelector: null
            , SlideOpenerClass: 'slide-opener'
            , ToggleButtonClass: 'toggle_button'
            , ToggleButtonOpenContent: '<i class="fas fa-chevron-circle-down"></i>'
            , ToggleButtonOpenScreenReaderText: '<span class="screen-reader-text">Open slider</span>'
            , ToggleButtonOpenLabel: 'Open slider'
            , ToggleButtonCloseContent: '<i class="fas fa-chevron-circle-up"></i>'
            , ToggleButtonCloseScreenReaderText: '<span class="screen-reader-text">Close slider</span>'
            , ToggleButtonCloseLabel: 'Close slider'
            , SlidingContentSelector: null
            , HideSliderClass: 'hiddenslider'
        },

        _destroy: function ()
        {
        },

        _init: function ()
        {
        },

        _MySlideNumber: null,
        
        _create: function ()
        {       
            var self = this;
            var jElement = $(self.element);

            if (self.options.DisplaySelector == null
                || self.options.SlideOpenerClass == null
                || self.options.ToggleButtonClass == null
                || self.options.ToggleButtonOpenContent == null
                || self.options.ToggleButtonOpenScreenReaderText == null
                || self.options.ToggleButtonOpenLabel == null
                || self.options.ToggleButtonCloseContent == null
                || self.options.ToggleButtonCloseScreenReaderText == null
                || self.options.ToggleButtonCloseLabel == null
                || self.options.SlidingContentSelector == null
                || self.options.HideSliderClass == null)
            {
                return;
            }
            
            var lDisplayElement = jElement.find(self.options.DisplaySelector);
            var lSlidingContent = jElement.find(self.options.SlidingContentSelector);
            
            if (lDisplayElement.length != 1
                || lSlidingContent.length != 1)
            {
                return;
            }
            
            mSlideOpenerCounter = mSlideOpenerCounter += 1;
            self._MySlideNumber = mSlideOpenerCounter;
            
            var lSlideContentId = 'SliderContent' + self._MySlideNumber;


            lDisplayElement.append(
                '<a href="#" role="button" class="'
                + self.options.ToggleButtonClass
                + '" aria-controls="'
                + lSlideContentId
                + '">'
                + self.options.ToggleButtonOpenContent
                + self.options.ToggleButtonOpenScreenReaderText
                + '</a>'
            );

            var lToggleButton = lDisplayElement.find('.' + self.options.ToggleButtonClass);
            lToggleButton.attr('title', self.options.ToggleButtonOpenLabel);
            lDisplayElement.attr('aria-expanded', 'false');
            
            lToggleButton.click(
                function (aEvent) 
                {
                    aEvent.preventDefault();
                    self.ToggleSlider();
                    return false;
                }
            );
            
            lSlidingContent.addClass(self.options.HideSliderClass);
            lSlidingContent.attr('id', lSlideContentId);
            jElement.addClass(self.options.SlideOpenerClass);
        },
        
        ToggleSlider: function()
        {
            var self = this;
            var jElement = $(self.element);
            
            var lSlidingContent = jElement.find(self.options.SlidingContentSelector);
            
            if (lSlidingContent.hasClass(self.options.HideSliderClass))
            {
                self._openSlider();
            }
            else
            {
                self._closeSlider();
            }
        },
        
        CloseSlider: function()
        {
            var self = this;
            self._closeSlider();
        },
        
        _openSlider: function()
        {
            var self = this;
            var jElement = $(self.element);

            var lSlidingContent = jElement.find(self.options.SlidingContentSelector);
            lSlidingContent.removeClass(self.options.HideSliderClass);
            
            self._setToggleButtonText();
        },
        
        _closeSlider: function()
        {
            var self = this;
            var jElement = $(self.element);

            var lSlidingContent = jElement.find(self.options.SlidingContentSelector);
            lSlidingContent.addClass(self.options.HideSliderClass);
            
            self._setToggleButtonText();
        },
        
        _setToggleButtonText: function()
        {
            var self = this;
            var jElement = $(self.element);

            var lDisplayElement = jElement.find(self.options.DisplaySelector);
            var lToggleButton = lDisplayElement.find('.' + self.options.ToggleButtonClass);
            var lSlidingContent = jElement.find(self.options.SlidingContentSelector);
                              
            if (lSlidingContent.hasClass(self.options.HideSliderClass))
            {
                lToggleButton.html(self.options.ToggleButtonOpenContent + self.options.ToggleButtonOpenScreenReaderText);
                lToggleButton.attr('title', self.options.ToggleButtonOpenLabel);
                lDisplayElement.attr('aria-expanded', 'false');
            }
            else
            {
                lToggleButton.html(self.options.ToggleButtonCloseContent + self.options.ToggleButtonCloseScreenReaderText);
                lToggleButton.attr('title', self.options.ToggleButtonCloseLabel);
                lDisplayElement.attr('aria-expanded', 'true');
            }
        }
        
    });
})(jQuery);